import { useLanguage } from "../context/LanguageContext";
import { PageHero, PageCta } from "../components/PageHero";
import { Reveal, FadeIn } from "../components/motion";

export default function About() {
  const { t } = useLanguage();
  const p = t.pages.about;
  return (
    <main data-testid="about-page">
      <PageHero testId="about-hero" label={p.label} title={p.title} sub={p.heroSub} />

      <section data-testid="about-story" className="bg-paper">
        <div className="mx-auto max-w-[1600px] px-6 py-28 sm:px-12 sm:py-40 md:px-16">
          <div className="grid gap-16 lg:grid-cols-12">
            <FadeIn className="lg:col-span-5">
              <div className="relative">
                <div className="overflow-hidden">
                  <img
                    src="/images/david-portrait-new.jpg"
                    alt="David Frank — Porträt"
                    loading="eager"
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
                <div className="mt-8">
                  <p className="font-head text-xl text-ink">{p.name}</p>
                  <p className="mt-2 text-[13px] font-medium uppercase tracking-label text-wave">{p.role}</p>
                </div>
              </div>
            </FadeIn>
            <div className="lg:col-span-6 lg:col-start-7">
              <Reveal delay={0.2}>
                <h2 className="font-head text-2xl leading-tight text-ink sm:text-3xl">{p.storyTitle}</h2>
              </Reveal>
              {p.story.map((para, i) => (
                <Reveal key={i} delay={0.25 + i * 0.08}>
                  <p className="mt-6 text-base font-light leading-relaxed text-ink/80 sm:text-lg">{para}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section data-testid="about-workshop" className="bg-white pt-20 sm:pt-24">
        <FadeIn>
          <img
            src="/images/workshop-wide.jpg"
            alt="David Frank in einer Workshop-Situation mit Teilnehmenden"
            loading="lazy"
            className="block aspect-[16/10] w-full object-cover object-[12%_center] sm:aspect-[21/9] lg:aspect-auto"
          />
        </FadeIn>
      </section>

      <section data-testid="about-qualifications" className="grain relative overflow-hidden bg-deep text-white">
        <div className="mx-auto max-w-[1600px] px-6 py-28 sm:px-12 sm:py-40 md:px-16">
          <div className="grid gap-16 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <Reveal y={14}>
                <p className="text-[13px] font-medium uppercase tracking-label text-wave">{p.qualLabel}</p>
              </Reveal>
              <Reveal delay={0.15}>
                <h2 className="font-head mt-8 text-3xl leading-tight sm:text-4xl">{p.qualTitle}</h2>
              </Reveal>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              {p.quals.map((q, i) => (
                <Reveal key={q} delay={i * 0.05} className="border-t border-white/10 py-5 first:border-t-0 first:pt-0">
                  <p className="text-sm font-light leading-relaxed text-white/70 sm:text-base">{q}</p>
                </Reveal>
              ))}
            </div>
          </div>
          <div className="mt-24 grid gap-16 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <Reveal y={14}>
                <p className="text-[13px] font-medium uppercase tracking-label text-wave">{p.expLabel}</p>
              </Reveal>
              <Reveal delay={0.15}>
                <h2 className="font-head mt-8 text-3xl leading-tight sm:text-4xl">{p.expTitle}</h2>
              </Reveal>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              {p.expItems.map((item, i) => (
                <Reveal key={item} delay={i * 0.07} className="border-t border-white/10 py-5 first:border-t-0 first:pt-0">
                  <p className="text-sm font-light leading-relaxed text-white/70 sm:text-base">{item}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <PageCta title={p.ctaTitle} text={p.ctaText} />
    </main>
  );
}
